import { Component, createContext, ReactNode } from 'react';

import { BraxStepProps } from '../BraxStep';

type StepperContextValue = {
    active?: BraxStepProps['id'],
    add: (tab: BraxStepProps) => void,
    remove: (id: BraxStepProps['id']) => void,
    setEnable: (id: BraxStepProps['id'], enable: boolean) => void,
    setTitle: (id: BraxStepProps['id'], title: ReactNode) => void,
    steps: BraxStepProps[]
};

const StepperContext = createContext<StepperContextValue>({} as any);

StepperContext.displayName = 'StepperContext';

export type StepperProviderProps = Pick<StepperContextValue, 'active'> & {
    children: ReactNode
};

type StepperProviderState = Omit<StepperContextValue, 'active'>;

export class StepperProvider extends Component<StepperProviderProps, StepperProviderState> {

    state: StepperProviderState = {
        add: (step: BraxStepProps) => this.add(step),
        remove: (id: BraxStepProps['id']) => this.remove(id),
        setEnable: (id: BraxStepProps['id'], enable: boolean) => this.setEnable(id, enable),
        setTitle: (id: BraxStepProps['id'], title: ReactNode) => this.setTitle(id, title),
        steps: []
    };

    add(step: BraxStepProps) {
        this.setState(prevState => ({
            steps: [...prevState.steps, step]
        }));
    }

    remove(id: BraxStepProps['id']) {
        this.setState(prevState => ({
            steps: prevState.steps.filter(step => step.id !== id)
        }));
    }

    setEnable(id: BraxStepProps['id'], enable: boolean) {
        this.setState(prevState => ({
            steps: prevState.steps.map(step => step.id === id ? ({ ...step, enable }) : step)
        }));
    }

    setTitle(id: BraxStepProps['id'], title: ReactNode) {
        this.setState(prevState => ({
            steps: prevState.steps.map(step => step.id === id ? ({ ...step, title }) : step)
        }));
    }

    render() {
        return (
            <StepperContext.Provider value={{ active: this.props.active || this.state.steps[0]?.id, ...this.state }}>
                { this.props.children }
            </StepperContext.Provider>
        );
    }

}

export default StepperContext;
